import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from 'src/constants';
import useCustomSnackbarGlobal from 'src/hooks/useSnackbarGlobal';
import ApiService from 'src/modules/api-service';
import { SearchAgentDTO, SearchAgentRequestDTO } from 'src/modules/generated/api';

export const useSearchAgentUpdate = () => {
  const queryClient = useQueryClient();
  const snackbar = useCustomSnackbarGlobal();
  const { t } = useTranslation();
  const mutation = useMutation(
    ({ id, ...searchAgent }: SearchAgentRequestDTO & { id: string }) =>
      ApiService.searchAgent.searchAgentControllerUpdateSearchAgent(id, searchAgent),
    {
      onMutate: async (updatedSearchAgent) => {
        await queryClient.cancelQueries([QueryKeys.searchAgents]);

        const snapshot = queryClient.getQueryData<SearchAgentDTO[]>([QueryKeys.searchAgents]);

        queryClient.setQueryData<SearchAgentDTO[]>([QueryKeys.searchAgents], (prev = []) =>
          prev.map((searchAgent) => {
            if (searchAgent.id === updatedSearchAgent.id) {
              return updatedSearchAgent;
            }
            return searchAgent;
          }),
        );

        return snapshot;
      },
      onError: (err, _updateSearchAgent, snapshot) => {
        console.error('[useSearchAgentUpdate] updateSearchAgent failed', err);
        queryClient.setQueryData<SearchAgentDTO[] | undefined>([QueryKeys.searchAgents], snapshot);
        snackbar.showError(t('searchAgentsPage.messages.error'));
      },
      onSettled: () => {
        queryClient.invalidateQueries([QueryKeys.searchAgents]);
      },
    },
  );

  return mutation;
};
